import Component from '@bythepixel/component-loader';
import { selectors } from './config';
import Repositioner from './Repositioner';

export default class ComplyAutoController extends Component {
  static selector = '[data-comp-comply-auto-controller]';

  complyAutoContainer;

  constructor(containerEl) {
    super(containerEl);

    this.repositioner = new Repositioner();
    this.mount();
  }

  setComplyAutoContainer() {
    const MAX_ATTEMPTS = 10;
    let attempts = 0;

    const callback = (res, rej) => {
      const interval = setInterval(() => {
        if (attempts === MAX_ATTEMPTS) {
          clearInterval(interval);
          rej();
        }

        const container = document.getElementById(selectors.caContainer);

        if (!container) {
          attempts += 1;
          return;
        }

        this.complyAutoContainer = container;
        clearInterval(interval);
        res();
      }, 500);
    };

    return new Promise(callback);
  }

  mount() {
    this.setComplyAutoContainer()
      .then(() => {
        this.repositioner.mount(this.complyAutoContainer);
      })
      .catch(() => console.error('Could not find Comply Auto container.'));
  }
}
